import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-stopPlaying",
  "use": "icon-stopPlaying-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-stopPlaying\"><path d=\"M0 0l1024 0 0 1024L0 1024 0 0z\" p-id=\"2301\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol